
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/UI/Card.vue';
import Icone from '@/core/components/UI/Icone.vue';
import ManualPreenchimentoInspecao from '@/models/Constantes/ManualPreenchimentoInspecao';
import { IInspecaoSecao1 } from '@/models/Entidades/IInspecao';

export default defineComponent({
  name: 'InspecaoSecao1',
  props: {
    secao1: {
      type: Object as () =>IInspecaoSecao1,
      required: true,
    },
    bloquearCampos: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Card,
    Icone,
  },
  emits: ['update:secao1', 'change'],
  setup(props, { emit }) {
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
      manuaisPreenchimento: {} as Record<string, boolean>,
    });

    const computedSecao1 = computed({
      get: () => props.secao1,
      set: (valor: IInspecaoSecao1) => {
        emit('update:secao1', valor);
      },
    });

    function change() {
      emit('change');
    }

    function alternarManualPreenchimento(chave: string) {
      state.manuaisPreenchimento[chave] = !state.manuaisPreenchimento[chave];
    }

    return {
      props,
      computedSecao1,
      state,
      change,
      ManualPreenchimentoInspecao,
      alternarManualPreenchimento,
    };
  },
});
